import { useSelector } from 'react-redux';
import Link from 'next/link';
import React from 'react';
import { Serie, SPORT_CATEGORIES } from '@root/src/types';
import useSerieInfo from '@root/src/hooks/useSerieInfo';
import getRoute from '@services/routeList';
import { selectEventById } from '@features/eventList/slices/eventListServerSliceState';
import { SerieCardRaw } from '@features/serieDetail/components/SerieCard/index';

interface SerieCardForEventsListProps {
  serieID: number;
  className?: string;
}
export const SerieCardForEventsList = ({
  serieID,
  className,
}: SerieCardForEventsListProps) => {
  const serie = useSelector(selectEventById(serieID)) as Serie;
  const { generateTags } = useSerieInfo(serie);

  return (
    <div>
      <Link href={getRoute.series(serie.slug).description()}>
        <a>
          <SerieCardRaw
            className={className}
            serieCategory={serie.serieCategory ?? SPORT_CATEGORIES.other}
            name={serie.name}
            year={serie.year}
            dateFrom={serie.serieDates.earliestEventDate}
            dateTo={serie.serieDates.latestEventDate}
            location={serie.locations?.join(', ')}
            serieType={serie.serieType}
            tags={generateTags()}
          />
        </a>
      </Link>
    </div>
  );
};
